<template>
  <div class>
    <button class="btn_blue" @click.prevent="show">
      Ny
    </button>
    <modal name="modal-create" :adaptive="true" height="auto" :scrollable="true" :width="450" @opened="opened">
      <div class="px-5 py-5">
        <h2 class="mb-4 text-xl tracking-wide">NY ANVÄNDARE</h2>

        <ValidationObserver ref="form" v-slot="{ invalid }">
          <form @submit.prevent="onCreate()">
            <ValidationProvider v-slot="{ errors }" name="Användarnamn" rules="required">
              <span class="text-gray-700">Användarnamn</span>
              <input v-model="user.userName" type="text" class="w-full mt-1 form-input" :class="{
                  'border-red-600 focus:border-red-600': errors[0]
                }" />
              <span class="block mt-1 text-sm text-red-500">{{
                errors[0]
              }}</span>
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors }" name="Lösenord" rules="required">
              <span class="text-gray-700">Lösenord</span>
              <input v-model="user.password" type="password" class="w-full mt-1 form-input" :class="{
                  'border-red-600 focus:border-red-600': errors[0]
                }" />
              <span class="block mt-1 text-sm text-red-500">{{
                errors[0]
              }}</span>
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors }" name="Förnamn" rules="required">
              <span class="text-gray-700">Förnamn</span>
              <input v-model="user.firstName" type="text" class="w-full mt-1 form-input" :class="{
                  'border-red-600 focus:border-red-600': errors[0]
                }" />
              <span class="block mt-1 text-sm text-red-500">{{
                errors[0]
              }}</span>
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors }" name="Efternamn" rules="required">
              <span class="text-gray-700">Efternamn</span>
              <input v-model="user.lastName" type="text" class="w-full mt-1 form-input" :class="{
                  'border-red-600 focus:border-red-600': errors[0]
                }" />
              <span class="block mt-1 text-sm text-red-500">{{
                errors[0]
              }}</span>
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors }" name="Email" rules="required|email">
              <span class="text-gray-700">Email</span>
              <input v-model="user.email" type="text" class="w-full mt-1 form-input" :class="{
                  'border-red-600 focus:border-red-600': errors[0]
                }" />
              <span class="block mt-1 text-sm text-red-500">{{
                errors[0]
              }}</span>
            </ValidationProvider>
            <div>
              <ValidationProvider name="Resarverad">
                <label class="inline-flex items-center mt-5">
                  <input type="checkbox" class="form-checkbox" v-model="user.reserved" />
                  <span class="form-label ml-2">Resarverad</span>
                </label>
              </ValidationProvider>
            </div>
            <div class="flex justify-end mt-10 mb-1">
              <button type="submit" class="block btn_blue" :class="{ 'opacity-50': invalid }" :disabled="invalid">Spara</button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      user: {
        userName: "",
        email: "",
        password: "",
        firstName: "",
        lastName: "",
        reserved: false
      }
    };
  },

  methods: {
    ...mapActions("usersStore", ["add"]),
    show() {
      this.$modal.show("modal-create");
    },
    opened() {
      // this.cart.description = "";
      // this.$refs.description.focus();
    },
    // hide() {
    //   this.$modal.hide("modal-create");
    // },
    async onCreate() {
      await this.add(this.user);
      this.$modal.hide("modal-create");
    }
  }
};
</script>
